import { createElement } from "react"
import type { ReactElement, ReactNode } from "react"

import { Loadable, RootLoaderFallback } from "@/3514/components"

import elements from "./participant.onboarding.elements"
import type { TParticipantOnboardingPageProps as TPageProps } from "./participant.onboarding.ui.types"

function participantOnboardingPageRenderer({
    page,
    isLoaded,
    isLoading
}: {
    page: (props: TPageProps) => ReactElement
    isLoaded: boolean
    isLoading: boolean
}): ReactElement {
    return createElement(
        elements.Container,
        void 0,
        ((props: TPageProps): ReactElement =>
            createElement(Loadable, {
                component: page(props),
                isReady: isLoaded,
                isLoading,
                loadingFallback: createElement(RootLoaderFallback)
            })) as unknown as ReactNode
    )
}

export { participantOnboardingPageRenderer }
